/*
 * @Author: xieyu7
 * @Date: 2019-01-25 17:36:19
 * @Last Modified by: chentingrui
 * @Last Modified time: 2023-06-Tu 03:40:37
 */

import axios from 'axios'
import MD5 from '../utils/md5'
import weui from 'weui.js'
import router from '../route/router'

import { setCookie, getCookie, delCookie, getCurPageWithParam } from '../utils/index.js'
const base64 = require('js-base64').Base64
/* 是否正在refresh */
let isRefresh = false
/* 重试队列 */
let waitRequst = []

/* 刷新token */
function getRefreshToken() {
  return service({
    url: '/auth/v2/api/refreshToken',
    method: 'post',
    data: { refreshToken: getCookie('refreshToken') }
  })
}

/* 生成签名 */
// function Sign(params){
//     let str =[];//'ns=' + nsValue + '&token=' + app.globalData.loginToken.token + '&ts=' + timestamp + '&key=' + nsValue;
//     let keys = Object.keys(params);
//     for(let i = 0; i< keys.length; i++){
//         if(params[keys[i]] !== null && params[keys[i]] !== ''){
//             str.push( keys[i] + '=' + params[keys[i]] ); // 键值对
//         }
//     }
//     str.sort().push('key=' + params.ns); // 排序后 尾部加key
//     str = str.join('&'); //用&分隔
//     return MD5.md5(str).toUpperCase(); // 加密后再大写
// }

/* 根据环境选择请求头 */
function getBaseURL() {
  if (process.env.NODE_ENV === 'production') {
    /* 打包 服务器地址前缀 */
    // return '../clientApi';
    return './api/'
  }
  /* 使用 http://www.hikparking.com.cn/wechat_dev/xxx  地址访问时使用这一条*/
  // return 'https://www.hikparking.com.cn/gateway/dev' //  开发环境
  // return 'https://www.hikparking.com.cn/gateway/dev2/'; //  充电环境
  // return 'http://www.hikparking.com.cn/gateway_system' //  系统测试k
  return 'https://www.hikparking.com.cn/gateway/lz_develop/' //  集成测试
  // return 'https://www.hikparking.com.cn/gateway/160_dev' //  160开发环境
  // return 'https://api.clouds.hikparking.com/'
  // return 'https://www.hikparking.com.cn/gateway/kaifeng_beta' //  集成测试
}

const service = axios.create({
  baseURL: getBaseURL(),
  timeout: 10000,
  transformRequest: [
    function(data) {
      // Do whatever you want to transform the data
      return JSON.stringify(data)
    }
  ],
  headers: {
    // 'Content-Type': 'application/x-www-form-urlencoded'
    'Content-Type': 'application/json'
  }
})

// request 拦截器
service.interceptors.request.use(
  (config) => {
    /*  do sth with config */
    /* 请求头处理 */
    config.headers.Authorization = getCookie('token') || ''
    config.headers.ClientType = localStorage.getItem('clientType') || 2
    config.headers['CustomPayload'] = base64.encode(
      JSON.stringify({
        ns: MD5.getRandom(),
        ts: Date.parse(new Date()),
        driverDealerId: parseInt(localStorage.getItem('driverDealerId')),
        openid: localStorage.getItem('openid'),
        buyid: localStorage.getItem('buyid') || '',
        authModel: localStorage.getItem('sourceType') || config.authModel ? 1 : ''
      })
    )
    const whiteUrls = [
      '/charge/v2/api/parkOrders/msp/plateNo',
      '/cps/v2/api/chargingOrders/msp',
      '/charge/v2/api/parkOrders/msp/detail',
      '/charge/v2/api/parkOrders/msp/parkingPictures',
      '/basic/v2/api/pageRemark',
      '/dealer/v2/api/parkPayTypesFetch',
      '/charge/v2/api/payCharges',
      '/charge/v2/api/canbeEvaluate',
      '/charge/v2/api/parkOrderAppeals/msp',
      '/charge/v2/api/parkOrderAppeals/msp',
      '/basic/v2/api/sysDicts/findByDicType/msp',
      '/driver/v2/api/balanceInfo',
      '/driver/v2/api/plateCount',
      '/coupon/v2/api/couponsCount',
      '/charge/v2/api/parkOrders/msp/countUnfinished',
      '/driver/v2/api/driverGroupMembers/getMineGroups',
      // '/auth/v2/api/driver/loginInfo',
      '/charge/v2/api/parkOrders/msp',
      '/charge/v2/api/driverActiveCarOut',
      '/charge/v2/api/payCharges/batch',
      '/charge/v2/api/parkOrders/msp/usableCoupons'
    ]
    if (whiteUrls.indexOf(config.url) > -1) {
      config.headers['CustomPayload'] = base64.encode(
        JSON.stringify({
          ns: MD5.getRandom(),
          ts: Date.parse(new Date()),
          driverDealerId: parseInt(localStorage.getItem('driverDealerId')),
          openid: localStorage.getItem('openid'),
          buyid: localStorage.getItem('buyid') || '',
          authModel: 1
        })
      )
    }
    return config
  },
  (error) => {
    /* handle error */
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截处理器
/* 215状态为refreshtoken过期，由于token存储原则变更，215状态不在会出现 */
service.interceptors.response.use(
  async(response) => {
    /* do sth validation  */
    if (response.data.code === '200') {
      return Promise.resolve(response.data)
    } else if (response.data.code === '0xd12501001') {
      // refreshToken过期，跳转去登录页面
      weui.toast('请先登录', {
        duration: 3000,
        className: 'custom-toast-info'
      })
      delCookie('token')
      delCookie('refreshToken')
      localStorage.removeItem('reqJson')
      localStorage.removeItem('platInfo')
      const timer = setTimeout(function() {
        router.replace('/login?redirect=' + router.history.current.path)
        clearTimeout(timer)
      }, 3000)
    } else if (response.data.code === '401') {
      // token过期，根据refreshtoken刷新token
      if (!isRefresh) {
        isRefresh = true
        if (getCookie('token')) {
          await getRefreshToken()
            .then((resp) => {
              // 刷新成功，重发请求
              setCookie('token', resp.data.token)
              setCookie('refreshToken', resp.data.refreshToken)
              // 将新的Token设置到axios的默认请求头
              service.defaults.headers.Authorization = getCookie('token')
              // 将新的Token设置到重发的请求头
              response.config.headers.Authorization = getCookie('token')
              waitRequst.forEach((cb) => cb(resp.data.token))
              waitRequst = []
            })
            .finally(() => {
              isRefresh = false
            })
          // 请求重发

          return await service.request(response.config)
        } else {
          weui.toast('请先登录', {
            duration: 3000,
            className: 'custom-toast-info'
          })
          isRefresh = false
          const timer = setTimeout(function() {
            const redirect = getCurPageWithParam(router)
            if (redirect) { // 如果已在登录页，不进行重定向
              const enCodeUrl = encodeURIComponent(redirect)
              router.replace('/login?enCodeUrl=' + enCodeUrl)
            }
            clearTimeout(timer)
          }, 3000)
        }
      } else {
        return new Promise((resolve) => {
          waitRequst.push((token) => {
            // 将新的Token设置到重发的请求头
            response.config.headers.Authorization = token
            resolve(service.request(response.config))
          })
        })
      }
      return Promise.reject(response.data)
    } else if (response.data.code === '0x10d7500008') {
      /* 如果来源是出口码  直接跳转到输入车牌页面 220124 crq现场需求。*/
      if (localStorage.getItem('sourceType') === '5') {
        router.replace('/scanPayPage')
        return Promise.reject(response.data)
      }
      // 非车主不可以查看账单
      weui.dialog({
        title: '提示',
        content: response.data.msg,
        buttons: [
          {
            label: '确定',
            type: 'primary',
            onClick: function() {
              var isLppzApp = false
              const ua = navigator.userAgent.toLowerCase()
              const uaAppStr = ua ? ua.match(/BeStore/i) : '' // match方法返回的是对象
              const uaApp = uaAppStr || ''
              const uaAndroid = /android/i.test(ua) // test返回的是true/false
              const uaIos = /iphone|ipad|ipod/i.test(ua)
              if (uaApp.toString() === 'bestore') {
                // 必须将match返回的对象转成字符串
                isLppzApp = true
              } else {
                isLppzApp = false
              }
              if (window.AlipayJSBridge) {
                window.AlipayJSBridge.call('closeWebview') // 支付宝
              } else if (window.WeixinJSBridge) {
                window.WeixinJSBridge.call('closeWindow') // 微信，只是微信就用这个API。
              } else if (isLppzApp && uaAndroid) {
                window.obj.closePageLppzRequest('') // 安卓app
              } else if (isLppzApp && uaIos) {
                window.webkit.messageHandlers.closePageLppzRequest.postMessage(
                  ''
                ) // ios app
              } else {
                const opened = window.open('about:blank', '_self')
                opened.opener = null
                opened.close()
              }
            }
          }
        ]
      })
      return Promise.reject(response.data)
    } else if (response.data.code === '0xd12501021') { // 限制同一账号多设备在线
      document.querySelector('.weui-loading_toast').style.display = 'none'
      weui.confirm('该账号已在其他手机登录，请重新登录或尝试修改密码。', {
        buttons: [{
          label: '知道了',
          type: 'default',
          onClick: function() { console.log('no') }
        }]
      })
      delCookie('token')
      delCookie('refreshToken')
      localStorage.removeItem('reqJson')
      localStorage.removeItem('platInfo')
      const timer = setTimeout(function() {
        // router.replace('/login?redirect=' + router.history.current.path);
        router.replace('/login?redirect=/mine')
        clearTimeout(timer)
      }, 3000)
    } else if (response.data.code === '0xd12501022') { // 微信一键登录 未绑定手机号码
      router.push('/bindPhone')
    } else if (response.data.code === '0xd06510036') { // 车牌添加已被他人绑定
      weui.confirm(response.data.msg, {
        title: '',
        buttons: [{
          label: '取消',
          type: 'default',
          onClick: function() {
            // router.push("/carManage");
          }
        }, {
          label: '提交反馈',
          type: 'primary',
          onClick: function() {
            router.push({
              path: '/customerService/questionConsultation',
              query: {
                type: 5
              }
            })
          }
        }]
      })
    } else if (response.data.code === '0xd06510037') { // 删除车牌校验是否欠费
      weui.dialog({
        title: response.data.msg,
        content: '',
        className: 'specail-dialog-deleteplate',
        buttons: [
          {
            label: '立即补缴',
            type: 'primary',
            onClick: function() {
              router.push({
                path: '/multiPayPage',
                query: {
                  arrearsOnly: 1
                }
              })
            }
          }, {
            label: '误绑他人车牌',
            type: 'primary',
            onClick: function() {
              router.push({
                path: '/customerService/questionConsultation',
                query: {
                  type: 5
                }
              })
            }
          }, {
            label: '取消',
            type: 'default'
          }
        ]
      })
    } else if (response.data.code === '0x1306510012') { // 企业账户使用超时，请重试
      weui.toast(response.data.msg, {
        duration: 5000,
        className: 'custom-toast error'
      })
      // weui.dialog({
      //   title: response.data.msg,
      //   content: '',
      //   className: 'specail-dialog-deleteplate',
      //   buttons: [
      //     {
      //       label: '确定',
      //       type: 'primary',
      //       onClick: function() {
      //         location.reload()
      //       }
      //     }, {
      //       label: '取消',
      //       type: 'default'
      //     }
      //   ]
      // })
    } else if (response.data.code === '0x1310501001') { // 重新预约报错
      weui.confirm(response.data.msg, {
        buttons: [{
          label: '确定',
          type: 'primary',
          onClick: function() { router.go(-1) }
        }]
      })
      // weui.dialog({
      //   title: response.data.msg,
      //   content: '',
      //   className: 'specail-dialog-deleteplate',
      //   buttons: [
      //     {
      //       label: '确定',
      //       type: 'primary',
      //       onClick: function() {
      //         router.go(-1)
      //       }
      //     }
      //   ]
      // })
    } else {
      weui.toast(response.data.msg, {
        duration: 3000,
        className: 'custom-toast error'
      })
      return Promise.reject(response.data)
    }
  },
  (error) => {
    console.log(error)
    return Promise.reject(error)
  }
)

export default service
